





























import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class VRename extends Vue {
  @Prop({ default: "" }) value!: string;
  @Prop({ default: "default" }) variant!: string;
  @Prop() btnClass?: string;

  name = "";

  checkValue(text: string) {
    return text.length >= 1 ? true : false;
  }

  ok(bvModalEvt: any) {
    if (this.name === "") {
      alert("文字を入力してください");
      bvModalEvt.preventDefault();
    } else {
      this.$emit("ok", this.name);
    }
  }

  shown() {
    this.name = this.value;
    (this.$refs.input as any).focus();
  }
}
